<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700 text-uppercase">
          Content Configuration
        </h2>
        <v-breadcrumbs
          class="px-0 text-capitalize"
          :items="breadcrumbs"
        ></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9 class="pl-1 text-capitalize">
            {{
              isDetail
                ? 'Content Configuration Details'
                : id
                ? type + ' Content Configuration'
                : 'Create New Content Configuration'
            }}
          </v-flex>
          <v-flex xs3 class="text-right" v-if="isDetail || isEdit">
            <v-icon @click="getDetail" title="refresh">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-layout row wrap>
              <v-flex xs12 class="pa-0">
                <v-flex xs5 class="py-0 darkgrey--text">
                  <label class="darkblue--text">Category Icon</label>
                  <vue-uploader
                    v-if="isChange"
                    ref="imageUpload"
                    @afterComplete="uploadComplete"
                    :options="dropzoneOptions"
                  ></vue-uploader>
                  <div v-if="isChange" class="fs-11 mt-2">
                    File .svg
                  </div>
                  <div v-if="items.icon_name" class="my-2">
                    <img
                      v-if="!isChange"
                      :src="baseUrl + items.icon_name"
                      width="60px"
                    />
                  </div>
                  <v-btn
                    v-if="!isChange && !isDetail"
                    dark
                    small
                    color="green"
                    @click="isChange = true"
                    >Change</v-btn
                  >
                </v-flex>
                <v-row class="px-3">
                  <v-col cols="4" class="pr-2">
                    <ValidationProvider
                      name="Category"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <label class="darkblue--text">Category</label>
                      <v-text-field
                        id="category"
                        single-line
                        outlined
                        dense
                        placeholder="Category"
                        v-model="items.portalCategory"
                        required
                        :error-messages="errors"
                        :disabled="isDetail"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="5" class="pr-2">
                    <ValidationProvider
                      name="Category Link"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <label class="darkblue--text">Category Link</label>
                      <v-text-field
                        id="category"
                        single-line
                        outlined
                        dense
                        placeholder="Category Link must be include https://"
                        v-model="items.link"
                        required
                        :error-messages="errors"
                        :disabled="isDetail"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="auto" class="pt-10">
                    <v-btn v-if="!isDetail" color="green" dark @click="addRow"
                      ><v-icon>add</v-icon> Add Content</v-btn
                    >
                  </v-col>
                </v-row>

                <!-- <v-col xs9 class="pr-0 pt-0 py-0">
                  <v-row v-if="items.children.length > 0">
                    <v-col cols="4" class="py-0 pr-0">
                      <label class="darkblue--text">Title</label>
                    </v-col>
                    <v-col cols="4" class="py-0">
                      <label class="darkblue--text">Link</label>
                    </v-col>
                    <v-col cols="2" class="py-0">
                      <label class="darkblue--text">Order</label>
                    </v-col>
                  </v-row>
                </v-col> -->
                <v-row>
                  <template v-if="items.children.length > 0" class="pa-0">
                    <v-col cols="9" class="py-0">
                      <v-row class="py-0 px-3">
                        <v-col cols="4" class="py-0 pr-0">
                          <label class="darkblue--text">Title</label>
                        </v-col>
                        <v-col cols="5" class="py-0">
                          <label class="darkblue--text">Link</label>
                        </v-col>
                        <v-col cols="3" class="py-0">
                          <label class="darkblue--text">Order</label>
                        </v-col>
                      </v-row>
                    </v-col>
                  </template>
                </v-row>
                <v-row v-for="(sub, index) in items.children" :key="index">
                  <template v-if="!sub.isDeleted" class="pa-0">
                    <v-col cols="9" class="py-0">
                      <v-row class="py-0 px-3">
                        <v-col cols="4" class="py-0 pr-0">
                          <ValidationProvider
                            name="Title"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              id="title"
                              single-line
                              outlined
                              dense
                              placeholder="Title"
                              v-model="sub.name"
                              :disabled="isDetail"
                              required
                              :error-messages="errors"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="5" class="py-0 pr-0">
                          <ValidationProvider
                            name="Link"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              id="order"
                              single-line
                              outlined
                              dense
                              placeholder="Link must be include https://"
                              v-model="sub.link"
                              :disabled="isDetail"
                              required
                              :error-messages="errors"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="3" class="py-0 pr-0">
                          <ValidationProvider
                            name="Order"
                            rules="required|min_value:1"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              id="order"
                              single-line
                              outlined
                              dense
                              placeholder="Order"
                              v-model="sub.order_child"
                              :disabled="isDetail"
                              required
                              type="number"
                              :error-messages="errors"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="auto" class="py-1 px-0 pl-2" v-if="!isDetail">
                      <v-btn
                        style="margin-top: 1px"
                        color="red"
                        dark
                        @click="confirmRemove(index, sub.id)"
                        ><v-icon large class="icon-medium"
                          >delete_outline</v-icon
                        ></v-btn
                      >
                    </v-col>
                  </template>
                </v-row>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right pt-6 px-0">
              <v-spacer></v-spacer>
              <v-flex xs2 right>
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'finance-portal-content-config' }"
                >
                  {{ id === 'id' ? 'Cancel' : 'Back' }}
                </v-btn>
              </v-flex>
              <v-flex xs2 right v-if="!isDetail" class="ml-4">
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  type="submit"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';
import uploader from '../../../components/uploader/image';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'progress-dialog': ProgressDialog,
    'vue-uploader': uploader
  },
  props: ['id', 'type'],
  data() {
    return {
      isChange: true,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        acceptedFiles: '.svg',
        maxFiles: 1,
        maxFilesize: 3,
        addRemoveLinks: true,
        dictDefaultMessage:
          '<i class="fas fa-camera"></i><span class="primary--text">Click or Drop Icon Here to Upload</span>'
      },
      baseUrl: process.env.VUE_APP_BASE_URL + '/images/',
      items: {
        iconName: '',
        portalCategory: '',
        link: '',
        children: []
      },
      loading: false,
      progressDialogLoading: false,
      search: '',
      isDetail: false,
      isEdit: false,
      breadcrumbs: [
        {
          text: 'Financial Portal',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Content Configuration List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text:
            this.type === 'detail'
              ? 'Content Configuration Details'
              : this.type + ' Content Configuration',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ]
    };
  },
  mounted() {
    if (this.id !== 'id') {
      if (this.type === 'detail') {
        this.isDetail = true;
        this.isEdit = false;
        this.getDetail();
      } else if (this.type === 'edit') {
        this.isEdit = true;
        this.isDetail = false;
        this.getDetail();
      }
    } else {
      setTimeout(() => {
        this.progressDialogLoading = false;
        this.loading = false;
      }, 800);
    }
  },
  watch: {},
  computed: {},
  methods: {
    remove(index, id) {
      if (this.isEdit) {
        return (this.items.children = this.items.children.map(item => {
          console.log(item.id === id);
          if (item.id === id) {
            item.isDeleted = true;
          }
          return { ...item };
        }));
      } else {
        console.log(index);
        return this.items.children.splice(index, 1);
      }
    },
    confirmRemove(index, id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You can not recover this content.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        if (result.value) {
          this.remove(index, id);
          Swal.fire(
            'Deleted',
            'Content has been deleted successfully',
            'success'
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'Content has been undeleted', 'error');
        }
      });
    },
    addRow() {
      return this.items.children.push({
        name: '',
        isDeleted: false,
        link: '',
        order_child: null
      });
    },
    async getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      await this.$store
        .dispatch('categoryPortal/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            console.log(data);
            if (data.data[0].icon_name === null) {
              this.isChange = true;
            } else {
              this.isChange = false;
            }
            this.items.portalCategory = data.data[0].name;
            this.items.icon_name = data.data[0].icon_name;
            this.items.link = data.data[0].link;
            this.items.children = data.data[0].children;
            // this.items.children = data.data.detail.map(item => {
            //   return {
            //     id: item.id,
            //     menu: item.name,
            //     isDeleted: false,
            //     order: item.order
            //   };
            // });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        Swal.fire({
          title: '',
          text: 'Are you sure want to save this data?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes, save it!',
          cancelButtonText: 'No, cancel it!'
        }).then(result => {
          if (result.value) {
            this.savecontent();
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire(
              'Cancelled',
              'Your data has been cancelled to save.',
              'error'
            );
          }
        });
      }
    },
    savecontent() {
      this.progressDialogLoading = true;
      this.loading = true;
      if (this.isEdit) {
        const param = {
          name: this.items.portalCategory,
          icon_name: this.isChange ? this.items.iconName : this.items.icon_name,
          link: this.items.link,
          children: this.items.children
        };
        this.$store
          .dispatch('categoryPortal/update', { id: this.id, params: param })
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.$router.push({
                name: 'finance-portal-content-config'
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        this.$store
          .dispatch('categoryPortal/create', this.items)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.$router.push({
                name: 'finance-portal-content-config'
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      }
    },
    uploadComplete(file) {
      var fileType = file.file.name.split('.').pop();
      var fileTypes = ['svg'];
      var maxSize = 3145728;
      if (fileTypes.includes(fileType.toLowerCase())) {
        if (file.file.size <= maxSize) {
          let formData = new FormData();
          formData.append('images', file.file);
          this.progressDialogLoading = true;

          this.$store
            .dispatch('texts/upload', formData)
            .then(data => {
              this.progressDialogLoading = false;
              // let base = this.baseUrl + '/images/';
              // this.progressDialogLoading = false;
              if (data.code === 200) {
                this.items.iconName = data.data[0].nameFile;
              } else {
                this.progressDialogLoading = false;
                this.loading = false;
                Swal.fire('Failed!', data.message.text_en, 'error');
              }
            })
            .catch(err => {
              this.progressDialogLoading = false;
              this.loading = false;
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            });
        } else {
          Swal.fire('Failed!', `Max image size is ${maxSize} Kb`, 'error');
          this.$refs.imageUpload.fileRemoved();
        }
      } else {
        Swal.fire('Failed!', 'Image format must be .svg', 'error');
        this.$refs.imageUpload.fileRemoved();
      }
    }
  }
};
</script>
<style>
.icon-medium {
  font-size: 25px !important;
}
</style>
